import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, createSlots as _createSlots, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }

import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import {computed, inject, ref} from "vue";
import {
    isTextareaButtonInDropdown
} from "~/operatorApplication/vue/dialogs/dialog/textarea/TextareaButtonInterface";
import {DropdownInstance} from "element-plus";


const __default__ = {
    name: "OperatorApplicationDialogTextareaButton"
};

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    tooltip: {},
    icon: {},
    light: { type: Boolean },
    bold: { type: Boolean },
    disabled: { type: Boolean },
    loading: { type: Boolean },
    color: {},
    iconStyle: {},
    dropdownPlacement: { default: 'top-end' },
    isConfigButton: { type: Boolean },
    hideOnClick: { type: Boolean },
    whiteIcon: { type: Boolean }
  },
  emits: ["click", "command"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

let props = __props;
let emits = __emit;

let dropdown = ref<DropdownInstance>();

let inDropdownMenu = computed(() => inject(isTextareaButtonInDropdown, false) && !props.isConfigButton);

let isDropdownVisible = ref(false);
let isDropdownWasVisible = ref(false);

function onDropdownVisibleChange(value: boolean) {
    isDropdownVisible.value = value;
    if (value) {
        isDropdownWasVisible.value = true;
    }
}

function onClick() {
    if (!isDisabled.value) {
        emits('click');
        document.body.focus();
    }
}

let isDisabled = computed(() => props.disabled || props.loading);

__expose({
    isDropdownWasVisible: isDropdownWasVisible,
    isDropdownVisible: isDropdownVisible,
    closeDropdown: () => dropdown.value?.handleClose()
})

return (_ctx: any,_cache: any) => {
  const _directive_my_tooltip = _resolveDirective("my-tooltip")!

  return (_openBlock(), _createElementBlock("span", null, [
    _withDirectives((_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.$slots.dropdown ? 'el-dropdown' : 'span'), {
      trigger: "click",
      placement: __props.dropdownPlacement,
      class: _normalizeClass({'w-100': _unref(inDropdownMenu), 'd-inline-block': true}),
      "hide-on-click": __props.hideOnClick,
      persistent: "",
      ref_key: "dropdown",
      ref: dropdown,
      onCommand: _cache[0] || (_cache[0] = ($event: any) => (_unref(emits)('command', $event))),
      onVisibleChange: onDropdownVisibleChange
    }, _createSlots({
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass({
                    'textarea-button': !_unref(inDropdownMenu),
                    'white-icon': __props.whiteIcon,
                     disabled: _unref(isDisabled)
                }),
          onClick: onClick
        }, [
          (__props.loading)
            ? (_openBlock(), _createBlock(FontAwesomeIcon, {
                key: 0,
                icon: "circle-notch",
                class: "spinner text-primary",
                light: "",
                style: _normalizeStyle(__props.iconStyle)
              }, null, 8, ["style"]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("span", {
                  style: {"width":"1em","overflow":"visible"},
                  class: _normalizeClass({
                            'd-inline-block text-center': true,
                            'mr-3': _unref(inDropdownMenu) && !__props.loading
                        })
                }, [
                  _renderSlot(_ctx.$slots, "icon", _normalizeProps(_guardReactiveProps({inDropdownMenu: _unref(inDropdownMenu)}))),
                  (!_ctx.$slots.icon)
                    ? (_openBlock(), _createBlock(FontAwesomeIcon, {
                        key: 0,
                        icon: __props.icon,
                        light: __props.light,
                        bold: __props.bold,
                        class: _normalizeClass(__props.color ? `text-${__props.color}` : null),
                        style: _normalizeStyle(__props.iconStyle)
                      }, null, 8, ["icon", "light", "bold", "class", "style"]))
                    : _createCommentVNode("", true)
                ], 2),
                (_unref(inDropdownMenu))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(__props.tooltip), 1))
                  : _createCommentVNode("", true)
              ], 64))
        ], 2)
      ]),
      _: 2
    }, [
      (_ctx.$slots.dropdown)
        ? {
            name: "dropdown",
            fn: _withCtx(() => [
              _renderSlot(_ctx.$slots, "dropdown")
            ]),
            key: "0"
          }
        : undefined
    ]), 1064, ["placement", "class", "hide-on-click"])), [
      [_directive_my_tooltip, (__props.tooltip && !_unref(inDropdownMenu) && !_unref(isDropdownVisible)) ? {delay: 500, text: __props.tooltip} : null]
    ])
  ]))
}
}

})